import React from 'react'
import { PropTypes } from 'prop-types'
import {
  Container, Button, Alert, AsyncCombobox
} from '@sainsburys-tech/fable'
import { Search } from '@sainsburys-tech/icons'
import api from '../../utils/api'

class SupplierSelection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      supplierName: props.supplierName || props.supplier?.supplierName,
      supplierId: props.supplier?.supplierId || 0,
      showError: false,
    }

    this.suppliersPromise = null
  }

  componentWillUnmount() {
    this.siteSupplier()
  }

    getSuppliers = () => {
      if (!this.suppliersPromise) {
        this.suppliersPromise = api.getAllSuppliers()
          .then(data => data.map(item => ({ value: String(item.id), label: item.name })))
          .catch((e) => {
            // Keep promise usable even if fetch fails
            // eslint-disable-next-line no-console
            console.log(e)
            return []
          })
      }
      return this.suppliersPromise
    }

    handleSupplierInputChange = (value) => {
      this.setState({ supplierName: value, supplierId: 0, showError: false })
    }

    handleSupplierSelection = (option) => {
      if (!option || Array.isArray(option)) return

      this.setState({
        supplierId: parseInt(option.value, 10),
        supplierName: option.label,
        showError: false,
      })

      const selectedTime = this.props.taskTime
      selectedTime.minutes = []
      selectedTime.hours = []
      this.props.setTaskTime(selectedTime)
    }

    clearSupplierSelection = () => {
      this.setState({ supplierId: 0, supplierName: undefined, showError: false })
    }

    isFieldIsValid = () => {
      const { supplierId } = this.state
      return supplierId && supplierId > 0
    }

      handleSubmit = async () => {
        const { history } = this.props
        if (this.isFieldIsValid()) {
          history.push('/task')
        } else {
          this.setState({ showError: true })
        }
      }

      siteSupplier = () => {
        const {
          supplierName,
          supplierId
        } = this.state

        const {
          contractor, setSupplier, setSiteTask, setSupplierName
        } = this.props

        const supplierData = {
          supplierName,
          supplierId,
          acceptedTCs: contractor ? contractor.acceptedTCs : false
        }

        setSupplier(supplierData)
        setSupplierName(supplierName)
        setSiteTask({})
      }

      render() {
        const { supplierName, showError } = this.state
        return (
          <div className="dsib-supplierSelection">
            <Container size="xl">
              <div className="dsib-supplierSelection__inner">
                <h2 className="dsib-supplierSelection__title">Which supplier are you working for today?</h2>

                <div className="dsib-supplierSelection__field">
                  <AsyncCombobox
                    label="Find a supplier"
                    placeholder="Start typing supplier name"
                    leadingIcon={<Search />}
                    isRequired
                    isClearable
                    debounceWaitTime={300}
                    value={supplierName || ''}
                    onChange={this.handleSupplierInputChange}
                    onSelection={this.handleSupplierSelection}
                    onClear={this.clearSupplierSelection}
                    options={(value) => {
                      if (!value || value.length < 3) return Promise.resolve([])
                      return this.getSuppliers().then((options) => {
                        const lower = value.toLowerCase()
                        return options.filter(opt => opt.label.toLowerCase().includes(lower))
                      })
                    }}
                    inputProps={{
                      id: 'supplier',
                      name: 'supplier'
                    }}
                  />
                </div>

                {showError && (
                <div className="dsib-supplierSelection__error">
                  <Alert status="error" isOpen message="Please select a supplier" />
                </div>
                )}

                <div className="dsib-supplierSelection__actions">
                  <Button type="button" variant="primary" isFullWidth onClick={this.handleSubmit}>
                    Next
                  </Button>
                </div>
              </div>
            </Container>
          </div>
        )
      }
}

SupplierSelection.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  supplierName: PropTypes.string,
  supplier: PropTypes.shape({
    supplierName: PropTypes.string,
    supplierId: PropTypes.number
  }),
  contractor: PropTypes.shape({
    acceptedTCs: PropTypes.bool,
  }),
  taskTime: PropTypes.shape({
    hours: PropTypes.array,
    minutes: PropTypes.array
  }).isRequired,
  setSupplier: PropTypes.func.isRequired,
  setSupplierName: PropTypes.func.isRequired,
  setSiteTask: PropTypes.func.isRequired,
  setTaskTime: PropTypes.func.isRequired,
}

SupplierSelection.defaultProps = {
  supplier: undefined,
  supplierName: undefined,
  contractor: undefined,
}

export default SupplierSelection
